module.exports = __webpack_public_path__ + "media/assets/images/flags/se-4683b2c069a4ff5d2cb7cbfdfe908784.svg";